import { Controller } from "@hotwired/stimulus"

// This controller is used to trigger an event when a new notification is loaded on the screen
export default class extends Controller {
  static get values() {
    return { type: String }
  }

  connect() {
    this.dispatch("created", { detail: { type: this.typeValue }})
    this.element.remove()
  }
}
